import apiFetch from '../../../utils/apiFetch';

export const FEATURE_USAGE_STATUSES = Object.freeze(['claimed', 'replayed', 'already-claimed', 'rejected']);

export async function claimFeatureUsage({ campaignId, combatantId, featureId, turnSequence, resolutionId }) {
  if (!campaignId) return { status: 'rejected', reason: 'missing-combat-context', claimId: null, claimedByResolutionId: null };
  const response = await apiFetch(`/campaigns/${encodeURIComponent(campaignId)}/combat/feature-usage/claim`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ combatantId, featureId, turnSequence, resolutionId }),
  });
  let result;
  try { result = await response.json(); } catch (_error) { result = null; }
  if (!result || !FEATURE_USAGE_STATUSES.includes(result.status)) {
    return { status: 'rejected', reason: response.ok ? 'invalid-response' : 'server-error', claimId: null, claimedByResolutionId: null };
  }
  return result;
}

/**
 * Divine Smite: the server spends the Bonus Action and the chosen slot or free use for this hit, and answers
 * in the claim shape so a refusal only drops the smite's damage.
 */
export async function claimDivineSmite(claim, { onSpellSlotReconciled, onCharacterChange } = {}) {
  if (!claim.campaignId) return { status: 'rejected', reason: 'missing-combat-context', claimId: null, claimedByResolutionId: null };
  const response = await apiFetch(`/campaigns/${encodeURIComponent(claim.campaignId)}/paladin/divine-smite`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ resolutionId: claim.resolutionId, attackerId: claim.attackerId, targetId: claim.targetId, turnSequence: claim.turnSequence,
      kind: claim.kind, weaponInstanceId: claim.weaponInstanceId, use: claim.use, pool: claim.pool, slotLevel: claim.slotLevel, diceCount: claim.diceCount,
      ...(claim.spellId ? { spellId: claim.spellId } : {}) }),
  });
  let result;
  try { result = await response.json(); } catch (_error) { result = null; }
  if (!result || !FEATURE_USAGE_STATUSES.includes(result.status)) {
    return { status: 'rejected', reason: response.ok ? 'invalid-response' : 'server-error', claimId: null, claimedByResolutionId: null };
  }
  if (['claimed', 'replayed'].includes(result.status)) {
    if (result.resourceProfile) onSpellSlotReconciled?.(result.resourceProfile);
    if (result.spellcastingState) onCharacterChange?.(result.spellcastingState);
  }
  return result;
}
